var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconDashboardAvatarSelected = function SvgIconDashboardAvatarSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3F94FF",
    d: "M10.234 10.4c1.565 0 2.833-1.339 2.833-2.99 0-1.65-1.268-2.988-2.833-2.988S7.4 5.76 7.4 7.41 8.67 10.4 10.234 10.4M15.222 17.922l.255-4.4c.078-.944-.489-1.811-1.322-2.033-3.211-.856-6.145-.411-7.833 0-.856.21-1.434 1.089-1.356 2.033l.256 4.378c0 .122.1.211.21.211l.145.067c2.922 1.5 6.389 1.5 9.311 0l.133-.067c.112 0 .2-.089.212-.211z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#3F94FF",
    strokeMiterlimit: 10,
    strokeWidth: 0.7,
    d: "M10.233 19.287a9.089 9.089 0 1 0 0-18.178 9.089 9.089 0 0 0 0 18.178Z"
  })));
};
export default SvgIconDashboardAvatarSelected;